import { AxelType } from '../type';
import { assignWithDefined } from '../util';
import numberFormat from './number.format';

const DEFAULT_FINANCIAL_PRECISION = 2;

export default function financial(localeSettings = null, opts: any = {}): (data: AxelType) => any {
  const defaults = {
    precision: DEFAULT_FINANCIAL_PRECISION,
    sign: '(',
    type: 'f',
    symbol: true,
  };

  return numberFormat.call(null, localeSettings, assignWithDefined({}, defaults, opts));
}
